import { CSSObject } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createSelectFieldItemTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',

          ...(theme.typography.button as CSSObject),

          padding: theme.spacing(5),

          borderTopStyle: 'solid',
          borderTopWidth: '1px',
          borderTopColor: theme.palette.divider,

          '&:first-of-type': {
            borderTop: 'none',
          },

          '&.Mui-selected': {
            backgroundColor: 'transparent',
          },

          '&.Mui-focusVisible, &.Mui-selected:hover': {
            backgroundColor: theme.palette.search.checkbox['backgroundHover'],
          },
        },
      },
    },
  },
});
